import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=95efe55e&scoped=true&"
import script from "./CommonTable.vue?vue&type=script&lang=js&"
export * from "./CommonTable.vue?vue&type=script&lang=js&"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=95efe55e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95efe55e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
